export enum CollectionType {
    Group = "Group",
    Public = "Public",
}
